import { handleGaugeSource } from '@/utils'
export const selectOptions = [
  {
    value: null,
    label: '全部'
  },
  {
    value: -2,
    label: '已提交'
  },
  {
    value: -3,
    label: '未提交'
  }
]
export const tabs = [
  {
    value: 0,
    label: '量表'
  },
  {
    value: 1,
    label: '图片'
  },
  {
    value: 2,
    label: '全部'
  }
]
// 量表-表单
export const GaugeColumns = [
  {
    title: '量表名称',
    key: 'surveyName',
    dataIndex: 'surveyName',
    width: 180
  },
  {
    title: '状态',
    key: 'statusString',
    dataIndex: 'statusString',
    width: 100
  },
  {
    title: '量表结果',
    key: 'surveyScore',
    dataIndex: 'surveyScore',
    width: 100
  },
  {
    title: '发送人',
    key: 'sendName',
    width: 150,
    dataIndex: 'sendName',
    slots: {
      customRender: 'sendName'
    }
  },
  {
    title: '提交人',
    key: 'submit',
    dataIndex: 'submit',
    width: 150,
    slots: {
      customRender: 'submit'
    }
  },
  {
    title: '发送时间',
    key: 'sendAt',
    dataIndex: 'sendAt',
    width: 150
  },
  {
    title: '就诊人姓名',
    key: 'patientName',
    width: 120,
    dataIndex: 'patientName',
    customRender: ({ record }) => {
      return record.patientProfileCommonVO?.patientProfileName || '--'
    }
  },
  {
    title: '提交时间',
    key: 'writingAt',
    dataIndex: 'writingAt',
    width: 150
  },
  {
    title: '来源',
    key: 'surveySource',
    dataIndex: 'surveySource',
    width: 100,
    customRender: ({ text }) => {
      return handleGaugeSource(text)
    }
  },
  {
    title: 'ID',
    key: 'id',
    dataIndex: 'id',
    width: 80
  },
  {
    title: '操作',
    key: 'operation',
    fixed: 'right',
    width: 100,
    slots: {
      customRender: 'operation'
    }
  }
]
